
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ai-optout-instructions/spotify",
      function () {
        return require("private-next-pages/ai-optout-instructions/spotify/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ai-optout-instructions/spotify"])
      });
    }
  